import * as React from "react";
import {
  Box,
  CircularProgress,
  Divider,
  Grid,
  List,
  ListItem,
  ListSubheader,
  useMediaQuery,
  MenuItem,
  Checkbox,
  ListItemText,
  Radio,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Popover,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Filter from "../filters";
import { useDispatch, useSelector } from "react-redux";
import useInfiniteScroll from "react-infinite-scroll-hook";
import { useTheme } from "@emotion/react";
import {
  getCSVData,
  getSearchedSellers,
  resetAll,
  setCurrentStatus,
  setPage,
  getRegistrationData,
} from "../../redux/slices/sellerSlice";
import { useNavigate } from "react-router-dom";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  ACTIVESELLERMAPPING,
  REGISTEREDSELLERMAPPING,
  STATUSMAPPING,
} from "../../utils/constants";
import { formatDate, getSubtitleStatus, showProperDate } from "../../utils";
import { ROLES } from "../../utils/constants";

const SellerList = ({ sellerTab }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const [allRegisteredStatuses, setAllRegisterStatuses] = React.useState({});
  const [allActiveStatuses, setAllActiveStatuses] = React.useState({});

  const state = useSelector(
    ({
      seller: {
        currentStatus,
        searchedSellers,
        statuses,
        loading,
        isInput,
        activeStatuses,
        msal: { user },
        msal: { roles },
        page,
        searchTerm,
        hasNextPage,
        matchingResults,
        registrationData,
      },
    }) => ({
      currentStatus,
      searchedSellers,
      statuses,
      loading,
      isInput,
      activeStatuses,
      user,
      roles,
      page,
      searchTerm,
      hasNextPage,
      matchingResults,
      registrationData,
    })
  );

  const hasAccess = state.roles.some(
    (role) =>
      role === ROLES.SUPER_ADMIN ||
      role === ROLES.BUSINESS_ADMIN ||
      role === ROLES.BUSINESS_USER ||
      role === ROLES.IT_ADMIN
  );

  React.useEffect(() => {
    const registered = {};
    const active = {};
    if (state.statuses) {
      state.statuses.forEach((status) => {
        if (status.status_group === "Registered Sellers") {
          // registered.status_id = status.status_type;
          registered[status.status_en] = status.status_type;
        } else if (status.status_group === "Active Sellers") {
          // active.status_id = status.status_type;
          active[status.status_en] = status.status_type;
        }
      });

      setAllActiveStatuses({ ...active });
      setAllRegisterStatuses({ ...registered });
    }
  }, [state.statuses]);

  // React.useLayoutEffect(() => {
  //   window.scroll({top: pageYOffset})
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [state.searchedSellers])

  React.useEffect(() => {
    // state.user && fetchSeller();
    if (state.page > 0) {
      fetchSeller();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.page]);

  React.useEffect(() => {
    if (!hasAccess) return;
    state.user && fetchSeller();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.user, hasAccess]);

  React.useEffect(() => {
    if (!hasAccess) return;
    if (sellerTab) {
      state.searchTerm = "";
      const flag = false;
      const params = { status: "RALL", offset: flag ? 0 : state.page };
      dispatch(
        getSearchedSellers({
          params,
          isInput: false,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAccess]);

  React.useEffect(() => {
    if (!hasAccess) return;
    dispatch(getRegistrationData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAccess]);

  const isMobile = useMediaQuery((theme) =>
    theme.breakpoints.between("sm", "md")
  );
  const isTablet = useMediaQuery((theme) =>
    theme.breakpoints.between("md", "lg")
  );

  // const [currentStatus, setCurrentStatus] = React.useState("PR");
  const [activeSellerStatus, setActiveSellerStatus] = React.useState("");

  const fetchSeller = (id, flag = false) => {
    const params = {
      ...(state.isInput
        ? { searchTerm: state.searchTerm }
        : { status: id || state.currentStatus }),
      offset: flag ? 0 : state.page,
    };
    dispatch(
      getSearchedSellers({
        params,
        isInput: state.isInput,
      })
    );
  };

  const [sentryRef] = useInfiniteScroll({
    loading: state.loading,
    hasNextPage: state.hasNextPage,
    onLoadMore: () => dispatch(setPage()),
    rootMargin: "400px 0px 0px 0px",
  });

  // React.useEffect(() => {
  //   console.log("effffffffffffffffff");
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  // state.searchedSellers.reduce((acc, curr) => {
  //   acc[curr.status_type].push(curr);
  //   return acc;
  // }, allStatusData);

  // console.log(allStatusData);

  const handleStatusChange = (e) => {
    if (state.currentStatus === e.target.id) return;
    dispatch(resetAll());

    fetchSeller(e.target.id, true);
    setActiveSellerStatus("");
    dispatch(setCurrentStatus({ currentStatus: e.target.id }));
  };

  const handleActiveSellerStatusChange = (e) => {
    if (state.currentStatus === e.target.id) return;
    dispatch(resetAll());
    fetchSeller(e.target.id, true);
    setActiveSellerStatus(e.target.id);
    dispatch(setCurrentStatus({ currentStatus: e.target.id }));
  };

  const handleSellerClick = (id) => {
    navigate(`/${id}`);
    // setShowModal(id);
  };

  // const handleCSVExport = () => {
  //   dispatch(getCSVData());
  // };

  const registeredStatuses = REGISTEREDSELLERMAPPING.map((statusType) =>
    state.statuses?.find((item) => item.status_type === statusType)
  );

  const activeStatuses = ACTIVESELLERMAPPING.map((statusType) =>
    state.statuses?.find((item) => item.status_type === statusType)
  );

  // New state for export dropdown
  const [exportAnchorEl, setExportAnchorEl] = React.useState(null);
  const exportTriggerRef = React.useRef(null);
  const firstFocusableRef = React.useRef(null);
  const [selectedRegisteredSellers, setSelectedRegisteredSellers] =
    React.useState([]);
  const [selectedActiveSellers, setSelectedActiveSellers] = React.useState([]);
  const [allRegisteredSelected, setAllRegisteredSelected] =
    React.useState(true);
  const [allActiveSelected, setAllActiveSelected] = React.useState(true);

  const isExportOpen = Boolean(exportAnchorEl);

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setAllRegisteredSelected(true);
    setSelectedRegisteredSellers([]);
    setAllActiveSelected(true);
    setSelectedActiveSellers([]);
    setExportAnchorEl(null);
    // restore focus to trigger
    exportTriggerRef.current?.focus();
  };

  const handleExportSubmit = () => {
    const registered = [];
    const active = [];

    if (selectedRegisteredSellers.length) {
      selectedRegisteredSellers.forEach((status_type) => {
        registered.push(allRegisteredStatuses[status_type]);
      });
    } else if (allRegisteredSelected) {
      registered.push("RALL");
    }

    if (selectedActiveSellers.length) {
      selectedActiveSellers.forEach((status_type) => {
        active.push(allActiveStatuses[status_type]);
      });
    } else if (allActiveSelected) {
      active.push("AALL");
    }

    dispatch(getCSVData({ data: [...registered, ...active], closeDropDown: handleExportClose }));

    // handleExportClose();
  };

  React.useEffect(() => {
    if (isExportOpen) {
      // focus first focusable (Submit button)
      firstFocusableRef.current?.focus();
    }
  }, [isExportOpen]);

  const handleRegisteredAllChange = () => {
    setAllRegisteredSelected(true);
    setSelectedRegisteredSellers([]);
  };

  const handleActiveAllChange = () => {
    setAllActiveSelected(true);
    setSelectedActiveSellers([]);
  };

  const handleRegisteredSellerChange = (value, checked) => {
    if (checked) {
      setSelectedRegisteredSellers((prev) => {
        const next = [...prev, value];
        setAllRegisteredSelected(false);
        return next;
      });
    } else {
      setSelectedRegisteredSellers((prev) => {
        const next = prev.filter((item) => item !== value);
        if (next.length === 0) setAllRegisteredSelected(true);
        return next;
      });
    }
  };

  const handleActiveSellerChange = (value, checked) => {
    if (checked) {
      setSelectedActiveSellers((prev) => {
        const next = [...prev, value];
        setAllActiveSelected(false);
        return next;
      });
    } else {
      setSelectedActiveSellers((prev) => {
        const next = prev.filter((item) => item !== value);
        if (next.length === 0) setAllActiveSelected(true);
        return next;
      });
    }
  };

  return (
    <>
      <Filter sellerTab={sellerTab} />

      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile || isTablet ? "column" : "row",
          columnGap: 5,
          mb: 7,
          flex: 1,
        }}
      >
        {state.isInput ? (
          <Box sx={{ display: "flex", flexDirection: "column", flex: 0.7 }}>
            <ListItem
              elevation={4}
              sx={{
                cursor: "pointer",
                fontFamily: "Open Sans",
                borderRadius: 3,
                fontWeight: 600,
                pb: 2,
                ...(!(isMobile || isTablet) && {
                  p: 1.5,
                  boxShadow: "0 0 1rem #ccc",
                  pl: 2,
                  bgcolor: theme.palette.primary.contrastText,
                }),
                color: theme.palette.navbarBg,
              }}
            >
              {`Matching Results (${state.matchingResults})`}
            </ListItem>
          </Box>
        ) : (
          !(isMobile || isTablet) && (
            <Box sx={{ display: "flex", flexDirection: "column", flex: 0.7 }}>
              <Box>
                <List
                  sx={{
                    width: "100%",
                    zIndex: 2,
                  }}
                  subheader={
                    <ListSubheader
                      sx={{
                        bgcolor: theme.palette.background.default,
                        color: theme.palette.navbarBg,
                        position: "relative",
                        zIndex: 0,
                        lineHeight: "4.375rem",
                        pl: 0,
                        fontWeight: 400,
                        fontFamily: "Open Sans",
                      }}
                    >
                      {" "}
                      {state.loading && !state.isInput
                        ? null
                        : "Registered Seller"}
                    </ListSubheader>
                  }
                >
                  {registeredStatuses.map((status) => (
                    <>
                      <ListItem
                        elevation={
                          state.currentStatus === status?.status_type ? 4 : 0
                        }
                        sx={{
                          p: 1.5,
                          pl: 2,
                          cursor: "pointer",
                          color: theme.palette.darkBlue,
                          my: -0.2,
                          fontFamily: "Open Sans",
                          ...(state.currentStatus === status?.status_type && {
                            borderRadius: 3,
                            bgcolor: theme.palette.primary.contrastText,
                            boxShadow: "0 0 1rem #ccc",
                            color: theme.palette.navbarBg,
                            fontWeight: "600",
                          }),
                        }}
                        key={status?.status_type}
                        tabIndex={0}
                        onKeyUp={(e) =>
                          !e.shiftKey &&
                          (e.key === "Enter" || e.key === " ") &&
                          handleStatusChange(e)
                        }
                        id={status?.status_type}
                        onClick={handleStatusChange}
                      >
                        {status?.status_en}&nbsp;
                        {status?.count !== undefined && `(${status?.count})`}
                      </ListItem>
                      {state.loading && !state.isInput ? null : (
                        <Divider variant="middle" />
                      )}
                    </>
                  ))}
                </List>
              </Box>

              <Box>
                <List
                  sx={{
                    width: "100%",
                    bgcolor: theme.palette.background.default,
                  }}
                  subheader={
                    <ListSubheader
                      sx={{
                        bgcolor: theme.palette.background.default,
                        color: theme.palette.navbarBg,
                        position: "relative",
                        lineHeight: "3rem",
                        zIndex: 0,
                        pl: 0,
                        fontWeight: 400,
                        fontFamily: "Open Sans",
                      }}
                    >
                      {state.loading && !state.isInput
                        ? null
                        : "Active Sellers"}
                    </ListSubheader>
                  }
                >
                  {activeStatuses.map((status) => (
                    <>
                      <ListItem
                        elevation={
                          activeSellerStatus === status?.status_type ? 4 : 0
                        }
                        sx={{
                          p: 1.5,
                          pl: 2,
                          cursor: "pointer",
                          color: theme.palette.darkBlue,
                          my: -0.2,
                          fontFamily: "Open Sans",
                          ...(state.currentStatus === status?.status_type && {
                            borderRadius: 3,
                            bgcolor: theme.palette.primary.contrastText,
                            boxShadow: "0 0 1rem #ccc",
                            color: theme.palette.navbarBg,
                            fontWeight: "600",
                          }),
                        }}
                        id={status?.status_type}
                        key={status?.status_type}
                        tabIndex={0}
                        onKeyUp={(e) =>
                          !e.shiftKey &&
                          (e.key === "Enter" || e.key === " ") &&
                          handleActiveSellerStatusChange(e)
                        }
                        onClick={handleActiveSellerStatusChange}
                      >
                        {status?.status_en}&nbsp;
                        {status?.count !== undefined && `(${status?.count})`}
                      </ListItem>
                      {state.loading && !state.isInput ? null : (
                        <Divider variant="middle" />
                      )}
                    </>
                  ))}
                </List>
              </Box>
            </Box>
          )
        )}

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 2,
            overflowY: "scroll",
            height: "90vh",
          }}
        >
          {state.loading && !state.isInput ? null : state.roles.some(
            (role) =>
              role === ROLES.SUPER_ADMIN ||
              role === ROLES.BUSINESS_ADMIN ||
              role === ROLES.BUSINESS_USER
          ) ? (
            <>
              <Typography
                ref={exportTriggerRef}
                role="button"
                tabIndex={0}
                aria-haspopup="dialog"
                aria-expanded={isExportOpen}
                aria-controls={isExportOpen ? "export-popover" : undefined}
                onClick={handleExportClick}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleExportClick(e);
                  }
                }}
                sx={{
                  display: "flex",
                  alignSelf: "end",
                  color: theme.palette.darkBlue,
                  cursor: "pointer",
                  pr: 0.5,
                }}
              >
                <SaveAltIcon sx={{ color: theme.palette.icon }} />
                &nbsp; Export All Sellers
              </Typography>

              <Popover
                id="export-popover"
                open={isExportOpen}
                anchorEl={exportAnchorEl}
                onClose={handleExportClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{
                  sx: {
                    width: "300px",
                    maxHeight: "400px",
                    overflowY: "auto",
                    "& .MuiAccordion-root": {
                      boxShadow: "none",
                      "&:before": { display: "none" },
                      m: 0,
                    },
                  },
                }}
              >
                <Box
                  role="group"
                  onKeyDown={(e) => {
                    // Keep popover open on Tab; allow normal tab navigation
                    if (e.key === "Escape") {
                      e.stopPropagation();
                      handleExportClose();
                    }
                  }}
                >
                  <Accordion defaultExpanded sx={{ p: 0 }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon sx={{ color: "#000000" }} />}
                      sx={{
                        backgroundColor: "#F1F7FB",
                        minHeight: "56px !important",
                        "& .MuiAccordionSummary-content": { m: "0 !important" },
                        "& .MuiAccordionSummary-content.Mui-expanded": {
                          m: "0 !important",
                        },
                      }}
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontFamily: "Open Sans",
                          fontWeight: 600,
                          fontSize: "16px",
                          lineHeight: "24px",
                          color: "#000000",
                        }}
                      >
                        Registered Sellers
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0 }}>
                      <MenuItem
                        sx={{ p: 0 }}
                        onClick={handleRegisteredAllChange}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleRegisteredAllChange();
                          }
                        }}
                      >
                        <Radio
                          sx={{ color: "#1460AA" }}
                          checked={allRegisteredSelected}
                          onChange={handleRegisteredAllChange}
                        />
                        <ListItemText
                          primary="All"
                          sx={{
                            fontFamily: "Open Sans",
                            fontWeight: 400,
                            fontSize: "14px",
                            lineHeight: "20px",
                          }}
                        />
                      </MenuItem>
                      {Object.keys(allRegisteredStatuses).map((option) => (
                        <MenuItem
                          key={option}
                          sx={{ p: 0 }}
                          onClick={() =>
                            handleRegisteredSellerChange(
                              option,
                              !selectedRegisteredSellers.includes(option)
                            )
                          }
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handleRegisteredSellerChange(
                                option,
                                !selectedRegisteredSellers.includes(option)
                              );
                            }
                          }}
                        >
                          <Checkbox
                            sx={{ color: "#1460AA" }}
                            checked={selectedRegisteredSellers.includes(option)}                      
                          />
                          <ListItemText
                            primary={option}
                            sx={{
                              fontFamily: "Open Sans",
                              fontWeight: 400,
                              fontSize: "14px",
                              lineHeight: "20px",
                            }}
                          />
                        </MenuItem>
                      ))}
                    </AccordionDetails>
                  </Accordion>

                  <Accordion defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon sx={{ color: "#000000" }} />}
                      sx={{
                        backgroundColor: "#F1F7FB",
                        minHeight: "56px !important",
                        "& .MuiAccordionSummary-content": { m: 0 },
                        "& .MuiAccordionSummary-content.Mui-expanded": { m: 0 },
                      }}
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontFamily: "Open Sans",
                          fontWeight: 600,
                          fontSize: "16px",
                          lineHeight: "24px",
                          color: "#000000",
                        }}
                      >
                        Active Sellers
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0 }}>
                      <MenuItem
                        sx={{ p: 0 }}
                        onClick={handleActiveAllChange}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleActiveAllChange();
                          }
                        }}
                      >
                        <Radio
                          sx={{ color: "#1460AA" }}
                          checked={allActiveSelected}
                          onChange={handleActiveAllChange}
                        />
                        <ListItemText
                          primary="All"
                          sx={{
                            fontFamily: "Open Sans",
                            fontWeight: 400,
                            fontSize: "14px",
                            lineHeight: "20px",
                          }}
                        />
                      </MenuItem>
                      {Object.keys(allActiveStatuses).map((option) => (
                        <MenuItem
                          key={option}
                          sx={{ p: 0 }}
                          onClick={() =>
                            handleActiveSellerChange(
                              option,
                              !selectedActiveSellers.includes(option)
                            )
                          }
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handleActiveSellerChange(
                                option,
                                !selectedActiveSellers.includes(option)
                              );
                            }
                          }}
                        >
                          <Checkbox
                            sx={{ color: "#1460AA" }}
                            checked={selectedActiveSellers.includes(option)}                        
                          />
                          <ListItemText
                            primary={option}
                            sx={{
                              fontFamily: "Open Sans",
                              fontWeight: 400,
                              fontSize: "14px",
                              lineHeight: "20px",
                            }}
                          />
                        </MenuItem>
                      ))}
                    </AccordionDetails>
                  </Accordion>

                  <Box
                    sx={{
                      borderTop: "1px solid #E0E0E0",
                      minHeight: "36px",
                      p: 2,
                      bgcolor: "#FFFFFF",
                      position: "sticky",
                      bottom: 0,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      ref={firstFocusableRef}
                      variant="contained"
                      size="small"
                      sx={{
                        textTransform: "none",
                        fontFamily: "Open Sans",
                        px: 2,
                        fontWeight: 600,
                        fontSize: "16px",
                        lineHeight: "20px",
                        borderRadius: "20px",
                      }}
                      onClick={handleExportSubmit}
                    >
                      Submit
                    </Button>
                  </Box>
                </Box>
              </Popover>
            </>
          ) : null}

          <>
            {state.searchedSellers.map((data, index) => (
              <Box key={data.seller_id} sx={{ mb: 2 }}>
                <Grid
                  container
                  sx={{
                    display: "flex",
                    ...(!state.isInput && { mt: 2 }),
                    borderRadius: 4,
                    bgcolor: theme.palette.primary.contrastText,
                  }}
                >
                  <Grid item xs={10} md={4} sx={{ p: "1.5rem 0 2rem 1.5rem" }}>
                    <Typography
                      variant="h6"
                      fontWeight={"600"}
                      fontSize={"1.25rem"}
                      lineHeight={"1.625rem"}
                      gutterBottom
                    >
                      {data.company_name}
                    </Typography>
                    <Typography
                      sx={{ fontSize: "0.875rem" }}
                      color="#000000"
                      fontWeight={"400"}
                      gutterBottom
                    >  {(() => {
                      const raw = data.business_model_type || "";
                      let ids = [];

                      if (raw.trim().startsWith("{")) {
                        // stringified JSON objects, e.g. {"id":"CB","iata":null},{"id":"AG","iata":"33333332"}
                        try {
                          const parsed = JSON.parse(`[${raw}]`);
                          ids = parsed.map((item) => item.id);
                        } catch (e) {
                          ids = [];
                        }
                      } else {
                        // plain comma-separated codes, e.g. "CB,CO"
                        ids = raw.split(",").map((v) => v.trim());
                      }

                      return ids
                        .map(
                          (id) =>
                            state.registrationData.business_model?.find(
                              (item) => item.business_model_id === id
                            )?.business_model_type
                        )
                        .filter(Boolean)
                        .join(", ");
                    })()}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: ".875rem",
                        fontWeight: "400",
                        lineHeight: "1.375rem",
                        color: theme.palette[data.status_en],
                      }}
                      color={theme.palette.darkBlue}
                    >
                      {STATUSMAPPING[data.status_en]}&nbsp;&#124;
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: ".875rem",
                        fontWeight: "400",
                        lineHeight: "1.375rem",
                      }}
                      color={theme.palette.navbarBg}
                      gutterBottom
                    >
                      {`${getSubtitleStatus(data?.status_en)} ${formatDate(
                        showProperDate(data?.status_en)
                          ? data?.registration_date
                          : data?.modification_date
                      )}`}
                    </Typography>
                  </Grid>

                  {!isMobile && (
                    <Grid
                      item
                      md={1}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        py: 2,
                      }}
                    >
                      <Divider orientation="vertical" variant="fullWidth" />
                    </Grid>
                  )}

                  {!isMobile && (
                    <Grid item md={6} sx={{ py: "1.5rem" }}>
                      <Typography
                        sx={{
                          fontSize: ".75rem",
                          lineHeight: "1.125rem",
                          fontWeight: "400",
                        }}
                        color={theme.palette.greyText}
                        gutterBottom
                      >
                        Business Contact
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: ".875rem",
                          lineHeight: "1.375",
                          fontWeight: "400",
                        }}
                        color={theme.palette.navbarBg}
                      >
                        {data.business_contact_name}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: ".875rem",
                          lineHeight: "1.375",
                          fontWeight: "400",
                        }}
                        color={theme.palette.navbarBg}
                      >
                        ({data.business_email})
                      </Typography>
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={2}
                    md={1}
                    tabIndex={0}
                    onKeyUp={(e) =>
                      !e.shiftKey &&
                      (e.key === "Enter" || e.key === " ") &&
                      handleSellerClick(data.seller_id)
                    }
                    sx={{ alignSelf: "stretch", cursor: "pointer" }}
                    onClick={() => handleSellerClick(data.seller_id)}
                    role="button"
                    aria-label={`more details about ${data.company_name}`}
                  >
                    <NavigateNextIcon
                      sx={{ color: theme.palette.icon, height: "100%" }}
                      fontSize="large"
                    />
                  </Grid>
                </Grid>

                {state.searchedSellers.length - 1 === index &&
                  state.searchedSellers.length >= 6 &&
                  state.hasNextPage && (
                    <Box
                      ref={sentryRef}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        py: "2rem",
                      }}
                    >
                      <CircularProgress />
                    </Box>
                  )}
              </Box>
            ))}
            {state.loading &&
              !state.isInput &&
              !state.searchedSellers.length ? (
              <CircularProgress
                sx={{
                  mt: isMobile ? "10rem" : "12rem",
                  ml: isMobile ? "8rem" : "20rem",
                  mb: isMobile ? "20rem" : "10rem",
                }}
              />
            ) : null}
            {!state.searchedSellers.length &&
              !state.loading &&
              !(isMobile || isTablet) && (
                <Typography textAlign={"center"}>
                  There are no sellers matching this status.
                </Typography>
              )}
          </>
        </Box>
      </Box>
    </>
  );
};

export default SellerList;
